<template>

  <div v-if="userStore.isLoggedIn()" class="container mol-typical-page-container-20">

    <div class="row">

      <!--    alert announcing any invites that need accepting -->
      <div v-for="invite in invites_received" :key="invite._id" >
        <FriendCard_InviteReceived :friend="invite" @update-friends-list="getFriendReport()"></FriendCard_InviteReceived>
      </div>

      <!--    invite code card -->
      <div :class="show_wide_invite_card? 'col-12' : 'col-lg-6'">
        <FriendCard_ShowCode></FriendCard_ShowCode>
      </div>

      <!--    friends -->
      <div v-for="friend in confirmed_friends" :key="friend._id" class="col-lg-6">
        <FriendCard_Friend :friend="friend" @update-friends-list="getFriendReport()"></FriendCard_Friend>
      </div>

      <!--    invited users look like faded-out friends  -->
      <!--        <div v-if="invites_sent.length > 0" style="margin-top: 50px; margin-bottom: 50px; color: cornflowerblue;">-->
      <!--          <hr>-->
      <!--          <h6><i class="fa fa-hourglass-1" aria-hidden="true"></i> waiting for their confirmation...</h6>-->
      <!--        </div>-->

      <div v-for="invite in invites_sent" :key="invite._id" class="col-lg-6" >
        <FriendCard_InviteSent :friend="invite" @update-friends-list="getFriendReport()"></FriendCard_InviteSent>
      </div>
    </div>

    <div v-if="show_friends_description" class="row">
      <div class="col-12 friends-description">
        <p><b>Invite friends to connect with you in myOscarList.</b></p>
        <p><i class="fa fa-check-square-o" aria-hidden="true"></i> Share films you've seen.</p>
        <p><i class="fa fa-check-square-o" aria-hidden="true"></i> Compare achievements you've earned.</p>
        <p><i class="fa fa-check-square-o" aria-hidden="true"></i> Find the next film you watch together.</p>
      </div>
    </div>

  </div>

</template>


<script>
import axios from "axios";
import {userStore} from "@/userStore";
import FriendCard_Friend from "@/components/friends/cards/FriendCard-Friend.vue";
import FriendCard_InviteReceived from "@/components/friends/cards/FriendCard-InviteReceived.vue";
import FriendCard_InviteSent from "@/components/friends/cards/FriendCard-InviteSent.vue";
import FriendCard_ShowCode from "@/components/friends/cards/FriendCard-ShowCode.vue";
import analytics from "@/analytics";


export default {
  name: "FriendsPage",
  components: {
    FriendCard_ShowCode, FriendCard_Friend, FriendCard_InviteReceived, FriendCard_InviteSent },
  data() {
    return {
      friendReport: null
    }
  },
  computed: {
    userStore() {
      return userStore;
    },
    show_friends_description() {
      // if there are NO friend cards, show our description
      return (
          this.friendReport &&
          (this.confirmed_friends.length + this.invites_received.length + this.invites_sent.length) === 0
      );
    },
    show_wide_invite_card() {
      // show the invite card wide if we're showing the description.
      return this.show_friends_description;

      // experimented with showing a wide invite card if there were an even number of friends, so the bottom would always be full.
      //return ( this.confirmed_friends.length % 2 === 0 );
    },
    confirmed_friends() {
      return this.friendReport?.confirmed;
    },
    invites_sent() {
      return this.friendReport?.invites_sent;
    },
    invites_received() {
      return this.friendReport?.invites_received;
    },
  },
  async created() {
    return this.getFriendReport()
        .catch((err) => {
          analytics.notifyBugsnagOfError(err);
        });
  },
  methods : {
    async getFriendReport() {
      //console.log(`getFriendReport()`);
      return axios
          .get("/api/friend/report")
          .then((response) => {
            this.friendReport = response.data;
          })
          .catch((err) => {
            analytics.notifyBugsnagOfError(err);
            this.friendReport = {
              confirmed: [],
              invites_sent: [],
              invites_received: []
            };
          });
    },
  }
}
</script>


<style scoped>

.row {
  margin-left: auto;
  margin-right: auto;
}

.friends-description {
  margin-top: 10px;
  text-align: center;
  font-size: large;
  color: var(--mol-friends-color);

  b {
    margin-bottom: 2em;
  }
}

.card {
  margin: 20px;
}

.invited-friend-card {
  opacity: 40%;
}

.friend-name {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.badge {
//opacity: 75%;
  margin-left: 2px;
  font-size: 50%;
  vertical-align: top;
}
.remove-friend-button {
  float: right;
  width: fit-content;

  .fa {
    color: var(--bs-card-border-color);
    font-size: 20px;
  //opacity: 40%;
  }
}
.alert {
  .invite-text {
    margin-bottom: 20px;
  }
  .friend-name {
    font-weight: 500;
    margin-bottom: 0px;
  }

  button {
    margin-top: 5px;
    margin-right: 5px;
    margin-left: 5px;
  }
}
</style>